import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem', color: '#333', lineHeight: '1.6' }}>
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> July 22, 2024</p>
      <p><strong>Website:</strong> https://synthetica-3bf2d.web.app/</p>

      <hr style={{ margin: '1.5rem 0', borderColor: '#eee' }} />

      <section>
        <h2>1. Information We Collect</h2>
        <p>We collect information to provide, maintain, and improve our services.</p>
        
        <h3>A. Information You Provide Directly</h3>
        <ul>
          <li><strong>Account Information:</strong> When you register or interact with the platform, we may collect your email address, authentication credentials, and user profile data via Firebase Authentication.</li>
          <li><strong>Submitted Content:</strong> Text, essays, or documents submitted to our text analysis and detection tools for classification.</li>
        </ul>

        <h3>B. Automatically Collected Information</h3>
        <ul>
          <li><strong>Usage Data:</strong> Log data, IP address, browser type, operating system, and timestamps of interactions with our services.</li>
          <li><strong>Cookies and Local Storage:</strong> Essential identifiers stored in local storage or browser cookies required to manage user sessions and maintain system state.</li>
        </ul>
      </section>

      <section>
        <h2>2. How We Use Your Information</h2>
        <p>We process your data for the following purposes:</p>
        <ul>
          <li>To authenticate user access and manage user accounts via Google Firebase.</li>
          <li>To perform requested text analysis and classification routines on submitted content.</li>
          <li>To prevent unauthorized activity, enhance database security, and protect server infrastructure.</li>
          <li>To analyze service usage and improve algorithm efficiency.</li>
        </ul>
      </section>

      <section>
        <h2>3. Data Processing and Storage</h2>
        <ul>
          <li><strong>Authentication and Database:</strong> Account data and user preferences are stored securely using Google Firebase infrastructure, subject to standard cloud security practices and access control rules.</li>
          <li><strong>Text Analysis Engine:</strong> Submitted text for detection or classification is processed via secure API endpoints on cloud hosting services.</li>
          <li><strong>Data Retention:</strong> We retain personal data only for as long as necessary to fulfill the purposes outlined in this policy or as required for operational and security reasons.</li>
        </ul>
      </section>

      <section>
        <h2>4. Third-Party Services</h2>
        <p>We integrate third-party services to support core application functions:</p>
        <ul>
          <li><strong>Google Firebase:</strong> For identity verification, cloud database operations, and web hosting.</li>
          <li><strong>PythonAnywhere:</strong> Hosting backend API services for text processing.</li>
        </ul>
        <p>These third-party providers handle your data according to their respective privacy policies and security protocols. We do not sell, rent, or trade your personal information to third parties.</p>
      </section>

      <section>
        <h2>5. Security Measures</h2>
        <p>We implement industry-standard security measures to safeguard your personal data:</p>
        <ul>
          <li>Transport Layer Security encryption for all network traffic.</li>
          <li>Strict Firestore rules ensuring user-level access restrictions for database records.</li>
          <li>Server-side CORS configurations preventing unauthorized cross-origin data exploitation.</li>
        </ul>
        <p>No method of electronic transmission or storage is 100% secure. While we strive to use commercially acceptable means to protect your personal data, absolute security cannot be guaranteed.</p>
      </section>

      <section>
        <h2>6. Your Rights</h2>
        <p>Depending on your jurisdiction, you may have rights regarding your personal data, including:</p>
        <ul>
          <li>The right to access or update your user account details.</li>
          <li>The right to request deletion of your account and associated user data.</li>
          <li>The right to restrict or object to certain types of processing.</li>
        </ul>
      </section>

      <section>
        <h2>7. Changes to This Privacy Policy</h2>
        <p>We reserve the right to update or modify this Privacy Policy at any time. Any updates will be posted on this page with an updated Effective Date. Continued use of Synthetica following changes indicates acceptance of the updated policy.</p>
      </section>

      <section>
        <h2>8. Contact Us</h2>
        <p>If you have questions, concerns, or requests regarding this Privacy Policy, contact us via the contact options available directly on the Synthetica web application platform.</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;